module.exports = __webpack_public_path__ + "img/text1_zhTc@3x.7ae979d9.png";